/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { SetUser } from 'blb-ui-types/login';

import { SignInPage } from './SignInPage';
import { UpdatePasswordChallengePage } from './UpdatePasswordChallengePage';
import { SetupMFAPage } from './SetupMFAPage';
import { PhoneMFAPage } from './PhoneMFAPage';
import { EmailMFAPage } from './EmailMFAPage';
import { SelectPrincipalPage } from './SelectPrincipalPage';
import { ForgotPasswordPage } from './ForgotPasswordPage';
import { ResetPasswordPage } from './ResetPasswordPage';
import { CookieMatchedRoute } from './CookieMatchedRoute';

import { InnerContainer, MiddleContainer, OuterContainer } from 'blb-components/IdentityLike/styles';
import { Header } from 'blb-components/IdentityLike';

export namespace UnauthenticatedApp {
  export interface Props {
    setMe: SetUser;
  }
}

export const UnauthenticatedApp: React.FC<UnauthenticatedApp.Props> = ({ setMe }) => {
  return (
    <OuterContainer>
      <MiddleContainer>
        <InnerContainer>
          <Header />
          <Switch>
            <CookieMatchedRoute exact path="/login">
              <SignInPage setMe={setMe} />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/login/update-password" redirectUrlOnFailedCookie="/login">
              <UpdatePasswordChallengePage setMe={setMe} />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/login/setup-mfa" redirectUrlOnFailedCookie="/login">
              <SetupMFAPage setMe={setMe} />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/login/sms-mfa" redirectUrlOnFailedCookie="/login">
              <PhoneMFAPage setMe={setMe} />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/login/email-mfa" redirectUrlOnFailedCookie="/login">
              <EmailMFAPage />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/login/select-principal" redirectUrlOnFailedCookie="/login">
              <SelectPrincipalPage setMe={setMe} />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/forgot-password">
              <ForgotPasswordPage />
            </CookieMatchedRoute>
            <CookieMatchedRoute exact path="/forgot-password/set-new-password" redirectUrlOnFailedCookie="/login">
              <ResetPasswordPage />
            </CookieMatchedRoute>
            <Route path="*">
              <Redirect to={{ pathname: '/login', search: window.location.search }} />
            </Route>
          </Switch>
        </InnerContainer>
      </MiddleContainer>
    </OuterContainer>
  );
};
